<mat-form-field class="size-sm w-full" floatLabel="auto">
  <mat-label class="px-2">{{ label | translate }}</mat-label>
  <mat-select (selectionChange)="onSelectionChange($event)"
              [formControl]="selectionControl"
              [compareWith]="compareFn"
              [multiple]="multiple">

    @if (multiple) {
      <mat-select-trigger>
        {{ selectionControl.value?.[0]?.['name'] || '' }}
        @if ((selectionControl.value?.length || 0) > 1) {
          <span>(+{{ (selectionControl.value?.length || 0) - 1 }} {{ selectionControl.value?.length === 2 ? 'other' : 'others' }}
            )</span>
        }
      </mat-select-trigger>
    }

    <mat-form-field *ngIf="showSearch" appearance="outline" class="size-sm w-full px/-2">
      <input [attr.aria-label]="filterPlaceholder"
             [formControl]="filterControl"
             [placeholder]="filterPlaceholder | translate"
             matInput type="text"
             (keydown)="keyDownHandler($event)"
      >
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    @for (option of (filteredOptions$ | async); track option) {
      <mat-option
        class="px-2"
        [value]="option">
        {{ option.name }}
      </mat-option>
    } @empty {
      <mat-option class="no-value" [value]="">{{ 'global.filter.itemsNotFound' | translate }}</mat-option>
    }

  </mat-select>

  @if (showClearButton$ | async) {
    <mat-icon (click)="clearInput($event)" matSuffix>cancel</mat-icon>
  }

</mat-form-field>
